import fetcher from '@/core/lib/fetcher'
import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { APIError, APIResponse } from '@/core/types/utils'
import { toast } from '../ui/use-toast'
import { BlogPost, BlogPostFormValues, BlogPosts } from './blog.types'

export const getBlogPosts = (token: string) =>
  queryOptions({
    queryKey: ['posts', token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + 'blog')
        .json<Promise<APIResponse<BlogPosts>>>(),
  })

export const createBlogPost = (blogPost: BlogPostFormValues, token: string) => {
  return fetcher
    .url(import.meta.env.VITE_API_BOOKING + 'blog')
    .auth(`Bearer ${token}`)
    .post(blogPost)
    .json()
}

export const getBlogPostById = (token: string, postId: string) =>
  queryOptions({
    queryKey: ['post', postId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(import.meta.env.VITE_API_BOOKING + `blog/${postId}`)
        .json<Promise<APIResponse<BlogPost>>>(),
  })

export const updateBlogPost = (
  data: BlogPostFormValues,
  token: string,
  postId: string
) => {
  return fetcher
    .url(import.meta.env.VITE_API_BOOKING + `blog/${postId}`)
    .auth(`Bearer ${token}`)
    .put(data)
    .json()
}

export const useDeleteBlogPost = (token: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      fetcher
        .auth(`Bearer ${token}`)
        .url(import.meta.env.VITE_API_BOOKING + `blog/${id}`)
        .delete()
        .json(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['posts', token],
      })
    },
    onError: (error) => {
      const errorObject: APIError<null> = JSON.parse(error.message)
      const errorMessage = errorObject.message
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      })
    },
  })
}
